// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { getFacebookData } from './facebook-profile-import';

/** @ngInject */
export function Controller(
    $scope,
    $state,
    $uibModal,
    AddProfileModal,
    Alert,
    RegistrationProfile,
) {
    this.$onInit = () => {

    if ($state.is('user.profiles') && this.profiles.length) {
        $state.go('.profile.main', {profileId: this.profiles[0].id}, {location: 'replace'});
    }

    $scope.profiles = this.profiles;
    $scope.facebookProfiles = new Array();
    $scope.userProfiles = new Array();

    $scope.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
    $scope.isHardTokenUser = this.account.roles.includes('ROLE_HARD_TOKEN_USER') || this.account.isSecondaryDeviceSession;

    /**
     * Separates all returned registration profiles into two arrays of user
     * profiles and facebook profiles.
     */
    var separateProfiles = function() {
        $scope.facebookProfiles = [];
        $scope.userProfiles = [];
        for (var i = 0; i < $scope.profiles.length; i++) {
            if ($scope.profiles[i].profileSource == "FACEBOOK") {
                $scope.facebookProfiles.push($scope.profiles[i]);
            } else {
                $scope.userProfiles.push($scope.profiles[i]);
               
            }
        }
    }

    separateProfiles();

    $scope.addProfile = () => {
        AddProfileModal()
            .then((profile) => {
                Alert('success', 'registration_profiles.messages.save');
                RegistrationProfile.query((profiles) => {
                    Object.assign($scope.profiles, profiles);
                    $state.go('user.profiles.profile', {profileId: profile.id});
                    separateProfiles();
                });
            });
    };

    $scope.importFacebookProfile = function() {
        getFacebookData().then((facebookData) => {
           
            RegistrationProfile.importFacebookProfile(facebookData, function(data) {
                $scope.profiles = RegistrationProfile.query(function() {
                    separateProfiles();
                    Alert('success', 'registration_profiles.messages.import');
                });
            });
        });
    }

    $scope.showProfilesInfo = () => $uibModal.open({component: 'profilesInfo'});
    $scope.showSocialProfilesInfo = () => $uibModal.open({component: 'socialProfilesInfo'});
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profiles.controller.js